import React, { useEffect, useState } from "react";

import { MenuProvider } from "./Store.js";

import MenuComponent from "./MenuComponent.js";
import { WebcamCapture } from "./WebcamComponent.js";

import Backdrop from "@mui/material/Backdrop";
import Typography from "@mui/material/Typography";
import Rotate90DegreesCcwRoundedIcon from "@mui/icons-material/Rotate90DegreesCcwRounded";

import "./App.css";

function App() {
  // Mask state
  const [mask, setMask] = useState(false);
  const handleCloseMask = () => {
    setMask(false);
  };
  const handleToggleMask = () => {
    setMask(!mask);
  };

  // Window rotation state
  const [screen, setScreen] = useState(window.screen.orientation);
  function applyMask() {
    if (screen.type === "landscape-primary") {
      console.log("Screen orientation: Landscape-primary.");
      handleCloseMask();
    } else if (
      screen.type === "portrait-secondary" ||
      screen.type === "portrait-primary"
    ) {
      console.log("Screen orientation: Potrait (please rotate).");
      handleToggleMask();
    } else if (screen.type === undefined) {
      console.log("The orientation API isn't supported in this browser :(");
    }
  }

  // Run initial mask
  useEffect(() => {
    applyMask();
    Notification.requestPermission();
  }, []);

  function doOnOrientationChange() {
    setScreen(window.screen.orientation);
    applyMask();
  }

  window.addEventListener("orientationchange", doOnOrientationChange);

  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={mask}
      >
        <Typography>Please rotate your phone </Typography>
        <Rotate90DegreesCcwRoundedIcon />
      </Backdrop>

      <MenuProvider>
        <MenuComponent />
        <WebcamCapture />
      </MenuProvider>
    </div>
  );
}

export default App;
